import { dAppDefinitionAddress } from "../../../constants";
import { RadixConnectProvider } from "../../../radix_connect";
import LeaderboardContent from "./LeaderboardContent";
import "./styles/index.scss";

const Leaderboard = () => {
  return (
    <RadixConnectProvider dAppDefinitionAddress={dAppDefinitionAddress}>
      <div className="min-h-screen bg-background text-foreground">
        <LeaderboardContent />
      </div>
    </RadixConnectProvider>
  );
};

export { LeaderboardContent };
export default Leaderboard;

